// extracted by mini-css-extract-plugin
export default {"followButton":"gR-z","followCount":"hR-z","textStyle":"iR-z"};